import { generateID } from 'react-querybuilder';

const DEFAULT_FILTER_OPTION = {
  text: '-',
  value: null,
};

export const handleEnums = (data = {}) => {
  if (!data || !Object.keys(data).length) {
    return {
      brands: [DEFAULT_FILTER_OPTION],
    };
  }

  const enums = {
    brands: [
      DEFAULT_FILTER_OPTION,
      ...Object.keys(data.models).map((key) => ({
        value: data.models[key].name,
        text: data.models[key].name,
        models: Object.keys(data.models[key].models).map((modelKey) => ({
          value: data.models[key].models[modelKey].name,
          text: `${data.models[key].models[modelKey].name} (${data.models[key].name})`,
        })),
      })),
    ],
  };

  return enums;
};

const getDescription = (vehicle) => {
  return [vehicle.brand_name, vehicle.model_name, vehicle.edition_label]
    .filter(Boolean)
    .join(' ');
};

const getDuration = (plan) => {
  return [plan.plan_duration, plan.plan_duration_unit]
    .filter(Boolean)
    .join(' ');
};

const convertCentstToEuros = (amountInCents) => {
  const euros = amountInCents / 100;
  return `${euros} €`;
};

export const handleCompetitionVehicles = (data = []) => {
  return data.flatMap((vehicle) =>
    vehicle.plans.map((plan) => ({
      id: generateID(),
      description: getDescription(vehicle) || '-',
      duration: getDuration(plan) || '-',
      brand_name: vehicle.brand_name || '-',
      model_name: vehicle.model_name || '-',
      edition_label: vehicle.edition_label || '-',
      transmission: vehicle.transmission || '-',
      engine_type: vehicle.engine_type || '-',
      year: vehicle.year || '-',
      plan_duration: plan.plan_duration || '-',
      plan_duration_unit: plan.plan_duration_unit || '-',
      km_allowance_per_period: plan.km_allowance_per_period || '-',
      monthly_price_cents: plan.monthly_price_cents
        ? convertCentstToEuros(plan.monthly_price_cents)
        : '-',
      downpayment_cents: plan.downpayment_cents
        ? convertCentstToEuros(plan.downpayment_cents)
        : '-',
      source_name: vehicle.source.name || '-',
    }))
  );
};
